import { Component, Vue } from "vue-property-decorator";

@Component
export default class FieldCustomValidity extends Vue {

	fieldModelKey: string = 'inputValue'

	fieldRef: string = 'input'

	onInvalidHandler() {
		this.setFieldCustomValidity((<any>this)[this.fieldModelKey] ? '' : this.$t('form.fill') as string);
	}

	setFieldCustomValidity(msg: string = '') {
		(<any>this).$refs[this.fieldRef] && (<any>this).$refs[this.fieldRef].setCustomValidity(msg || '');
	}

	unsetFieldCustomValidityByFieldValue() {
		if ((<any>this)[this.fieldModelKey]) this.setFieldCustomValidity();
	}

}